/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LayerResultsResponseDto } from './LayerResultsResponseDto';
import {
    LayerResultsResponseDtoFromJSON,
    LayerResultsResponseDtoFromJSONTyped,
    LayerResultsResponseDtoToJSON,
    LayerResultsResponseDtoToJSONTyped,
} from './LayerResultsResponseDto';

/**
 * 
 * @export
 * @interface LayerResultFilterResponse
 */
export interface LayerResultFilterResponse {
    /**
     * 
     * @type {Array<LayerResultsResponseDto>}
     * @memberof LayerResultFilterResponse
     */
    layers: Array<LayerResultsResponseDto>;
    /**
     * 
     * @type {LayerResultsResponseDto}
     * @memberof LayerResultFilterResponse
     */
    summary: LayerResultsResponseDto;
}

/**
 * Check if a given object implements the LayerResultFilterResponse interface.
 */
export function instanceOfLayerResultFilterResponse(value: object): value is LayerResultFilterResponse {
    if (!('layers' in value) || value['layers'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    return true;
}

export function LayerResultFilterResponseFromJSON(json: any): LayerResultFilterResponse {
    return LayerResultFilterResponseFromJSONTyped(json, false);
}

export function LayerResultFilterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LayerResultFilterResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'layers': ((json['layers'] as Array<any>).map(LayerResultsResponseDtoFromJSON)),
        'summary': LayerResultsResponseDtoFromJSON(json['summary']),
    };
}

export function LayerResultFilterResponseToJSON(json: any): LayerResultFilterResponse {
    return LayerResultFilterResponseToJSONTyped(json, false);
}

export function LayerResultFilterResponseToJSONTyped(value?: LayerResultFilterResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'layers': ((value['layers'] as Array<any>).map(LayerResultsResponseDtoToJSON)),
        'summary': LayerResultsResponseDtoToJSON(value['summary']),
    };
}

